// GET_CASHOUT_REQUEST
export const GET_CASHOUT_REQUEST = "GET_CASHOUT_REQUEST";

// UPDATE_CASHOUT_REQUEST
export const UPDATE_CASHOUT_REQUEST = "UPDATE_CASHOUT_REQUEST";

// GET_CASHOUT_STATS
export const GET_CASHOUT_STATS = "GET_CASHOUT_STATS";
